
import React from "react";
import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { TerraceFormValues } from "../SubmissionFormSchema";

interface TerraceDescriptionProps {
  form: UseFormReturn<TerraceFormValues>;
}

const TerraceDescription = ({ form }: TerraceDescriptionProps) => {
  return (
    <FormField
      control={form.control}
      name="terraceDescription"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Description</FormLabel>
          <FormControl>
            <Textarea {...field} rows={3} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default TerraceDescription;
